import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { login } from '../../redux/authenticator'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { LoginView } from './LoginView'

export const Login = () => {
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  
  const isLogged = useAppSelector(state => state.authenticator.isLogged)
  const loginError = useAppSelector(state => state.authenticator.loginPasswordError)

  // Get the original requested path or default to home
  const from = (location.state as any)?.from?.pathname || '/'

  // Redirect if already logged in
  useEffect(() => {
    if (isLogged) {
      navigate(from, { replace: true })
    }
  }, [isLogged, navigate, from])

  // Handle login errors
  useEffect(() => {
    if (loginError) {
      setError(true)
      setErrorMessage(loginError)
      setIsLoading(false)
    }
  }, [loginError])

  const handleSubmit = async () => {
    if (!email || !password) return
    
    setError(false)
    setErrorMessage('')
    setIsLoading(true)
    
    try {
      const result = await dispatch(login({ email, password })).unwrap()
      // Success is handled by the useEffect above
    } catch (err) {
      // Error is handled by the useEffect above
      setIsLoading(false)
    }
  }

  return (
    <LoginView
      error={error}
      errorMessage={errorMessage}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      setEmail={setEmail}
      setPassword={setPassword}
      email={email}
      password={password}
    />
  )
}